import axios from 'axios'
import Cookies from 'js-cookie'
import router from '@/router'
import qs from 'qs'
import { clearLoginInfo } from '@/utils'
import baseUrl from './baseUrl'
import isPlainObject from 'lodash/isPlainObject'
// console.log(baseUrl)
const http = axios.create({
  baseURL: baseUrl,  //环境配置
  timeout: 1000 * 180,
  withCredentials: true
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  config.headers['Accept-Language'] = Cookies.get('language') || 'zh-CN'
  config.headers['tenantCode'] = Cookies.get('tenantCode') || ''
  // console.log(config.url)
  if (
      config.url !== '/auth/oauth/token' &&
      config.url !== '/sys/params/getResultByCode/isRequireSMSVerification?resultType=1' &&
      config.url !== '/sys/user/sendCodeWithPassword' &&
      config.url !== '/sys/register/submit3' &&
      config.url !== '/sys/register/send-code' &&
      config.url !== '/sys/forget-pwd/send-code' &&
      config.url !== '/sys/forget-pwd/update-pwd'
    ) {
        config.headers['Authorization'] = 'Bearer ' + Cookies.get('access_token') || ''
    }
  // 默认参数
  var defaults = {}
  // 防止缓存，GET请求默认带_t参数
  if (config.method === 'get') {
    config.params = {
      ...config.params,
      ...{ '_t': new Date().getTime() }
    }
  }
  if (isPlainObject(config.params)) {
    config.params = {
      ...defaults,
      ...config.params
    }
  }
  if (isPlainObject(config.data)) {
    config.data = {
      ...defaults,
      ...config.data
    }
    if (/^application\/x-www-form-urlencoded/.test(config.headers['content-type'])) {
      config.data = qs.stringify(config.data)
    }
  }
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  // console.log(response)
  if (response.data.code === 401 || response.data.code === 10001) {
    clearLoginInfo()
    router.replace({ name: 'login' })
    return Promise.reject(response.data.msg)
  }
  return response
}, error => {
  // console.error(error)
  return Promise.reject(error)
})

export default http
